import {
  CustomPropertyAction as Action,
  CustomPropertyActionTypes as ActionTypes,
  CustomPropertyLayout,
  CustomPropertyLayoutSetting,
} from './types';

/**
 * @summary 初期化処理
 * @returns {Action}
 */
export const init = (): Action => ({ type: ActionTypes.INIT });

/**
 * @summary リフレッシュ処理
 * @returns {Action}
 */
export const refresh = (): Action => ({ type: ActionTypes.REFRESH });

/**
 * @summary Loading状態を保持
 * @param {boolean} isLoading
 * @returns {Action}
 */
export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
});

/**
 * @summary 送信処理中かを保持
 * @param {boolean} isSubmitting
 * @returns {Action}
 */
export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting,
});

/**
 * @summary カスタムプロパティの項目定義リストを保持
 * @param {CustomPropertyLayout[]} customPropertyLayoutList
 * @returns {Action}
 */
export const setCustomPropertyLayoutList = (
  customPropertyLayoutList: CustomPropertyLayout[],
): Action => ({
  type: ActionTypes.SET_CUSTOM_PROPERTY_LAYOUT_LIST,
  payload: customPropertyLayoutList,
});

/**
 * @summary カスタムプロパティの設定情報を保持
 * @param {CustomPropertyLayoutSetting[]} customPropertyLayoutSettingList
 * @returns {Action}
 */
export const setCustomPropertyLayoutSetting = (
  customPropertyLayoutSettingList: CustomPropertyLayoutSetting[],
): Action => ({
  type: ActionTypes.SET_CUSTOM_PROPERTY_LAYOUT_SETTING_LIST,
  payload: customPropertyLayoutSettingList,
});
